import axios from 'axios';
import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { userSelector } from '../../appStore/commonSlice';
import { USERAPI } from '../../const';
import { UpdateUser } from './UpdateUser';

const Usuario = (props) => {
  const [userData, setUserData] = useState({});
  const user = useSelector(userSelector);

  useEffect(() => {
    if (!user || !user.cuil) return;
    axios
      .get(`${USERAPI}/usuarios/cuil/${user.cuil}`)
      .then((res) => {
        setUserData(res.data);
      })
      .catch((err) => console.error(err));

    document.title = 'Concursar - Mi Perfil';
  }, []);

  return (
    <>
      <Container>
        <h2 className="header">Actualizar datos</h2>
        <UpdateUser userData={userData} />
      </Container>
    </>
  );
};
export default Usuario;
